export default __webpack_public_path__ + "static/media/OpenSans-ExtraBoldItalic.4014c919.ttf";